import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('orderPallets', orderPallets);

function orderPallets($translate) {
  return function orderPalletsFilter(orderPackagesRef, enableSuffix) {
    let sum;

    if (orderPackagesRef) {
      sum = orderPackagesRef.reduce((acc, item) => {
        if (item?.pallets) {
          acc += (item.pallets || 0);
          // acc += (item.pallets * (item.count || 1));
        }
        return acc;
      }, 0);
    }

    return enableSuffix ? $translate.instant(sum == 1 ? 'X_PALLET' : 'X_PALLETS', {sum: sum}) : sum;
  }
}
